<section class="sql-playground">
	<div class="details-tab--layout">
		<!-- Left Column: Version Files Card -->
		<div class="details-tab--left-panel">
			<div class="details-tab--version-files-card">
				<div class="details-tab--card-header">
					<h4 class="details-tab--card-title">Version Files</h4>
					<div class="details-tab--info-icon-wrapper">
						<svg
							class="details-tab--info-icon"
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							(mouseenter)="showVersionFilesTooltip($event)"
							(mouseleave)="hideVersionFilesTooltip()"
							title="Info"
						>
							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
							<path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
							<circle cx="12" cy="8" r="1" fill="currentColor"/>
						</svg>
						<div
							class="details-tab--info-tooltip"
							[style.top.px]="versionFilesTooltipTop"
							[style.left.px]="versionFilesTooltipLeft"
							[class.visible]="versionFilesTooltipVisible"
						>
							<p class="details-tab--tooltip-text">Data files (JSON, CSV, TSV, Parquet) from this dataset version that you can query.</p>
						</div>
					</div>
				</div>
				
			<!-- Loading state -->
			<div class="details-tab--files-loading" *ngIf="loadingFiles">
				<div class="details-tab--spinner"></div>
				<p>Loading files...</p>
			</div>

			<!-- Error state -->
			<div class="details-tab--files-error" *ngIf="filesError && !loadingFiles">
				<p>{{ filesError }}</p>
			</div>

			<!-- No files state -->
			<div class="details-tab--no-files" *ngIf="!loadingFiles && !filesError && displayFiles.length === 0">
				<p>No files available</p>
			</div>
				
			<!-- File Cards Grid -->
			<div class="details-tab--file-cards-grid" *ngIf="!loadingFiles && !filesError && displayFiles.length > 0">
				<div 
					*ngFor="let file of displayFiles" 
					class="details-tab--file-card"
					[class.selected]="file.isSelected"
					(click)="onFileCardClick(file)"
				>
					<!-- Single Row: File icon + File name + Info icon (only when selected) -->
					<div class="details-tab--file-card-row">
						<div class="details-tab--file-card-name-wrapper">
							<svg class="details-tab--file-card-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
								<path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span class="details-tab--file-card-name">{{ file.name }}</span>
						</div>
						<!-- Info icon: click toggles File details panel (only for selected files) -->
						<div 
							class="details-tab--info-icon-wrapper" 
							*ngIf="file.isSelected"
							(click)="toggleFileDetails(file.name, 'version'); $event.stopPropagation()"
						>
							<svg 
								class="details-tab--info-icon" 
								[class.details-tab--info-icon-expanded]="isFileDetailsExpanded(file.name, 'version')"
								width="16" 
								height="16" 
								viewBox="0 0 24 24" 
								fill="none"
								title="Toggle file details"
							>
								<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
								<path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
								<circle cx="12" cy="8" r="1" fill="currentColor"/>
							</svg>
						</div>
					</div>
					<!-- Inline File details panel (stays open so table name can be copied) -->
					<div 
						class="details-tab--file-details-panel" 
						*ngIf="isFileDetailsExpanded(file.name, 'version')"
						(click)="$event.stopPropagation()"
					>
						<div class="details-tab--tooltip-header">File details</div>
						<div class="details-tab--tooltip-body">
							<div class="details-tab--tooltip-row">
								<span class="details-tab--tooltip-label">Table name</span>
								<span class="details-tab--tooltip-value details-tab--tooltip-code details-tab--copyable" title="Select to copy">{{ generateTableNameFromFileName(file.name) }}</span>
							</div>
							<div class="details-tab--tooltip-row" *ngIf="file.size || displayFilesTotalSize">
								<span class="details-tab--tooltip-label">File size</span>
								<span class="details-tab--tooltip-value">{{ file.size || displayFilesTotalSize }}</span>
							</div>
							<div class="details-tab--tooltip-row" *ngIf="file.license || license">
								<span class="details-tab--tooltip-label">License</span>
								<span class="details-tab--tooltip-value">{{ file.license || license }}</span>
							</div>
							<div class="details-tab--tooltip-row" *ngIf="file.lastUpdated || displayFilesLastUpdated">
								<span class="details-tab--tooltip-label">Last updated</span>
								<span class="details-tab--tooltip-value">{{ file.lastUpdated || displayFilesLastUpdated }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- Custom Files Section -->
			<div class="details-tab--custom-files-section">
				<div class="details-tab--custom-files-header">
					<h4 class="details-tab--card-title">Custom Files</h4>
					<label class="details-tab--upload-icon-btn" [class.disabled]="isUploading || isRunning" title="Upload file">
						<input
							type="file"
							(change)="onFileSelected($event)"
							[accept]="fileInputAccept"
							[disabled]="isUploading || isRunning"
							style="display: none;"
						/>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
							<path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</label>
				</div>
				
				<!-- Custom Files List -->
				<div class="details-tab--custom-files-list" *ngIf="customFiles.length > 0">
					<div 
						*ngFor="let file of customFiles" 
						class="details-tab--custom-file-item-wrapper"
					>
						<div 
							class="details-tab--custom-file-item"
							[class.selected]="file.isSelected"
						>
							<input
								type="checkbox"
								class="details-tab--custom-file-checkbox"
								[checked]="file.isSelected"
								(change)="onCustomFileToggle(file)"
								id="custom-file-{{ file.name }}"
							/>
							<div class="details-tab--custom-file-content">
								<span class="details-tab--custom-file-name">{{ file.name }}</span>
							</div>
							<!-- Info icon: click toggles File details panel (only when selected) -->
							<div 
								class="details-tab--info-icon-wrapper" 
								*ngIf="file.isSelected"
								(click)="toggleFileDetails(file.name, 'custom'); $event.stopPropagation()"
							>
								<svg 
									class="details-tab--info-icon" 
									[class.details-tab--info-icon-expanded]="isFileDetailsExpanded(file.name, 'custom')"
									width="16" 
									height="16" 
									viewBox="0 0 24 24" 
									fill="none"
									title="Toggle file details"
								>
									<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
									<path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
									<circle cx="12" cy="8" r="1" fill="currentColor"/>
								</svg>
							</div>
							<!-- Remove file -->
							<button
								type="button"
								class="details-tab--custom-file-remove"
								(click)="removeCustomFile(file); $event.stopPropagation()"
								title="Remove file"
								aria-label="Remove file"
							>
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
									<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</button>
						</div>
						<!-- Inline File details panel (stays open so table name can be copied) -->
						<div 
							class="details-tab--file-details-panel details-tab--file-details-panel-custom" 
							*ngIf="isFileDetailsExpanded(file.name, 'custom')"
							(click)="$event.stopPropagation()"
						>
							<div class="details-tab--tooltip-header">File details</div>
							<div class="details-tab--tooltip-body">
								<div class="details-tab--tooltip-row" *ngIf="file.tableName">
									<span class="details-tab--tooltip-label">Table name</span>
									<span class="details-tab--tooltip-value details-tab--tooltip-code details-tab--copyable" title="Select to copy">{{ file.tableName }}</span>
								</div>
								<div class="details-tab--tooltip-row">
									<span class="details-tab--tooltip-label">File size</span>
									<span class="details-tab--tooltip-value">{{ file.size }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<!-- Empty State -->
				<div class="details-tab--custom-files-empty" *ngIf="customFiles.length === 0">
					<p>No custom files uploaded yet</p>
				</div>
			</div>
			</div>
		</div>
		
		<!-- Right Column: SQL Playground Content -->
		<div class="details-tab--right-panel">
			<div class="sql-playground__panel">
				<div class="sql-playground__editor-upload-wrapper">
			<div class="sql-playground__editor-container">
				<div class="sql-playground__editor-wrapper">
					<pre class="sql-playground__editor-highlight" [style.font-size.px]="editorFontSize"><code [innerHTML]="highlightedSql" [style.font-size.px]="editorFontSize"></code></pre>
					<textarea
						class="sql-playground__editor"
						[(ngModel)]="sql"
						[placeholder]="hasSelectedFiles ? 'Enter your SQL query here...' : 'Select a file to start querying...'"
						[style.height.px]="editorHeight"
						[style.font-size.px]="editorFontSize"
						(input)="onSqlInput($event)"
						(scroll)="onSqlScroll($event)"
					></textarea>
				</div>
				<!-- Editor Icons -->
				<div class="sql-playground__editor-icons">
					<button
						type="button"
						class="sql-playground__editor-icon-btn sql-playground__font-size-btn"
						(click)="decreaseFontSize()"
						title="Decrease font size"
					>
						<span class="sql-playground__font-icon">A</span>
						<span class="sql-playground__font-minus">−</span>
					</button>
					<button
						type="button"
						class="sql-playground__editor-icon-btn sql-playground__font-size-btn"
						(click)="increaseFontSize()"
						title="Increase font size"
					>
						<span class="sql-playground__font-icon">A</span>
						<span class="sql-playground__font-plus">+</span>
					</button>
					<button
						type="button"
						class="sql-playground__editor-icon-btn"
						(click)="resetPlayground()"
						[disabled]="isRunning || !canResetPlayground"
						title="Reset"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M12 8V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</button>
					<label
						class="sql-playground__editor-icon-btn"
						[class.disabled]="isUploading || isRunning"
						title="Upload file"
					>
						<input
							type="file"
							(change)="onFileSelected($event)"
							[accept]="fileInputAccept"
							[disabled]="isUploading || isRunning"
							style="display: none;"
						/>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</label>
					<button
						type="button"
						class="sql-playground__editor-icon-btn sql-playground__editor-icon-btn--run"
						(click)="runQuery()"
						[disabled]="isRunning || !hasSelectedFiles"
						title="Run Query"
					>
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" *ngIf="!isRunning">
							<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>
						</svg>
						<div class="sql-playground__editor-icon-spinner" *ngIf="isRunning"></div>
					</button>
				</div>
			</div>
		</div>

		<section class="sql-playground__results">
			<header class="sql-playground__results-header">
				<div>
					<h3 class="sql-playground__results-title">
						Query Results
					</h3>
				</div>
				<div
					class="sql-playground__results-meta"
					*ngIf="runStatus !== 'idle'"
				>
					<span *ngIf="executionTimeMs">
						Execution time: {{ executionTimeMs }} ms
					</span>
					<span *ngIf="resultRows.length">
						Rows: {{ resultRows.length }}
					</span>
				</div>
			</header>

			<div
				*ngIf="runStatus === 'error'; else resultsContent"
				class="sql-playground__error"
				role="alert"
			>
				<strong>Query failed.</strong>
				<span>{{ errorMessage }}</span>
			</div>
			<ng-template #resultsContent>
				<div
					class="sql-playground__results-body"
					*ngIf="resultRows.length; else noResults"
				>
					<div class="sql-playground__table-wrapper">
						<table class="sql-playground__table">
							<thead>
								<tr>
									<th *ngFor="let column of resultColumns">
										{{ column }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let row of resultRows">
									<td *ngFor="let column of resultColumns">
										{{ row[column] ?? '—' }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</ng-template>
			<ng-template #noResults>
				<div class="sql-playground__results-empty">
					<p *ngIf="runStatus === 'success'">
						No rows returned. Try adjusting filters or selecting
						different columns.
					</p>
					<p *ngIf="runStatus === 'idle'">
						Upload a file and run the query to preview sample
						output here.
					</p>
					<p *ngIf="runStatus === 'running'">
						Fetching results&hellip;
					</p>
				</div>
			</ng-template>
		</section>

		<footer class="sql-playground__footer">
			<span
				class="sql-playground__run-status"
				[ngClass]="{
					running: runStatus === 'running',
					success: runStatus === 'success'
				}"
				*ngIf="runStatus !== 'idle'"
			>
				<span *ngIf="runStatus === 'running'">Executing query…</span>
				<span *ngIf="runStatus === 'success'">
					Last run {{ lastRunAt | date: 'shortTime' }}
				</span>
			</span>
		</footer>
			</div>
		</div>
	</div>
</section>
